import { Action } from '@ngrx/store';
import { IGroup, IGroupElement, IGroupMember, IGroupType, IGroupElementType } from '../IGroups';
import { ITask } from '../../lookups/ITask';
import { IGroupResponse, IGroupMemberResponse, IGroupElementResponse, IGroupDeleteResponse } from '../IGroupsResponse';

export enum ActionTypes {
  LoadGroups = '[groups] Load Groups',
  LoadGroupMembers = '[groups] Load Group Members',
  LoadGroupElements = '[groups] Load Group Elements',
  LoadGroupElementTypes = '[groups] Load Group Element Types',
  LoadGroupTypes = '[groups] Load Group Types',
  SetGroups = '[groups] Set Groups',
  SetGroupMembers = '[groups] Set Group Members',
  SetGroupElements = '[groups] Set Group Elements',
  SetGroupElementTypes = '[groups] Set Group Element Types',
  SetGroupTypes = '[groups] Set Group Types',
  UpdateGroups = '[groups] Update Groups',
  UpdateGroupMembers = '[groups] Update Group Members',
  UpdateGroupElements = '[groups] Update Group Elements',
  UpdateGroupsSuccess = '[groups] Update Groups Success',
  UpdateGroupMembersSuccess = '[groups] Update Group Members Success',
  UpdateGroupElementsSuccess = '[groups] Update Group Elements Success',
  DeleteGroup = '[groups] Delete Group',
  DeleteGroupSuccess = '[groups] Delete Group Success',
  Reset = '[groups] Reset'
}

export class Reset implements Action {
  readonly type = ActionTypes.Reset;
}

export class LoadGroups implements Action {
  constructor(public payload?: {
    Categoryid: string
  }) {
  }
  readonly type = ActionTypes.LoadGroups;
}

export class LoadGroupMembers implements Action {
  constructor(public payload?: {
    GroupID: number,
    IsGroupMember?: boolean
  }) {
  }
  readonly type = ActionTypes.LoadGroupMembers;
}

export class LoadGroupElementTypes implements Action {
  constructor(public payload?: {
    GroupID: number
  }) { }

  readonly type = ActionTypes.LoadGroupElementTypes;
}

export class LoadGroupElements implements Action {
  constructor(public payload?: {
    GroupID: number,
    GroupElementTypeID: number,
    ListID: string,
  }) {
  }
  readonly type = ActionTypes.LoadGroupElements;
}

export class LoadGroupTypes implements Action {
  constructor() { }
  readonly type = ActionTypes.LoadGroupTypes;
}

export class SetGroups implements Action {
  constructor(public payload: Array<IGroup>) {
  }
  readonly type = ActionTypes.SetGroups;
}

export class SetGroupMembers implements Action {
  constructor(public payload: Array<IGroupMember>) {
  }
  readonly type = ActionTypes.SetGroupMembers;
}

export class SetGroupElements implements Action {
  constructor(public payload: Array<IGroupElement>) {
  }
  readonly type = ActionTypes.SetGroupElements;
}

export class SetGroupElementTypes implements Action {
  constructor(public payload: Array<IGroupElementType>) {
  }
  readonly type = ActionTypes.SetGroupElementTypes;
}

export class SetGroupTypes implements Action {
  constructor(public payload: Array<IGroupType>) {
  }
  readonly type = ActionTypes.SetGroupTypes;
}

export class UpdateGroups implements Action {
  constructor(public payload: Array<IGroup>) { }
  readonly type = ActionTypes.UpdateGroups;
}

export class UpdateGroupMembers implements Action {
  constructor(public payload: Array<IGroupMember>) { }
  readonly type = ActionTypes.UpdateGroupMembers;
}

export class UpdateGroupElements implements Action {
  constructor(public payload: Array<IGroupElement>) { }
  readonly type = ActionTypes.UpdateGroupElements;
}

export class UpdateGroupsSuccess implements Action {
  constructor(public payload: IGroupResponse) { }
  readonly type = ActionTypes.UpdateGroupsSuccess;
}

export class UpdateGroupMembersSuccess implements Action {
  constructor(public payload: IGroupMemberResponse) { }
  readonly type = ActionTypes.UpdateGroupMembersSuccess;
}

export class UpdateGroupElementsSuccess implements Action {
  constructor(public payload: IGroupElementResponse) { }
  readonly type = ActionTypes.UpdateGroupElementsSuccess;
}

export class DeleteGroup implements Action {
  constructor(public payload: Array<number>) { }
  readonly type = ActionTypes.DeleteGroup;
}
export class DeleteGroupSuccess implements Action {
  constructor(public payload: IGroupDeleteResponse) { }
  readonly type = ActionTypes.DeleteGroupSuccess;
}

export type ActionsUnion = LoadGroups
  | LoadGroupMembers | LoadGroupElements | LoadGroupElementTypes | LoadGroupTypes | SetGroups | SetGroupMembers | SetGroupElements | SetGroupElementTypes
  | SetGroupTypes | UpdateGroups | UpdateGroupMembers | UpdateGroupElements | UpdateGroupsSuccess | UpdateGroupMembersSuccess | UpdateGroupElementsSuccess | DeleteGroup | DeleteGroupSuccess | Reset
  ;
